import React from 'react'
import Page from '../components/containers/Page'
import Portfolio from '../components/Portfolio'
// import { useLocation } from 'react-router-dom'
import { project } from '../data/data'
import { LetsWork } from './Home'

const Work = () => {

  // const pageTitle = useLocation().pathname

  document.title = `WORK — ${project.website}`
  
  return (
    <Page>
      <Portfolio />
      <LetsWork />
    </Page>)
}

export default Work
